import React from 'react';
import ReactDOMClient from 'react-dom/client';
import singleSpaReact from 'single-spa-react';

import { App } from './app/App';

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
export const { bootstrap, mount, unmount } = singleSpaReact({
	React,
	ReactDOMClient,
	rootComponent: App,
	errorBoundary: () => <div>Error</div>,
	domElementGetter: () => {
		const el = document.getElementById(`single-spa-application:kubernetes-flex-calculator`);
		if (!el) {
			throw new Error(`DOM element for single-spa-application:kubernetes-flex-calculator not found`);
		}

		return el;
	},
});
